import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";
import { useSelector } from "react-redux";
// const fileData = useSelector((state) => state.document.fileData);

toast.configure();

export const getDocuments = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documents`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          if (response.docs) {
            dispatch({
              type: "LIST_DOCUMENT_MENU",
              data: response
            });
          }
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

export const getDocumentsWithTypes = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documents/withTypes`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          const res = JSON.parse(JSON.stringify(response));
          if (res?.docs?.length > 0) {
            res.docs[0].documents = {}
          }
          dispatch({
            type: "LIST_DOCUMENT_MENU",
            data: res
          });

          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    )
  }
};





export const unlockDoc = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documents/unlock/${params.docId}`, {}, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          toast.success('Document unlocked successfully');
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    )
  }
};

export const unAssignDoc = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/unAssignDoc`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          dispatch({ type: "DOCUMENT_DATA", data: response });
          toast.success('Document unassign successfully.');
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    )
  }
};

export const resetReadOnlyDoc = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documents/unlock/${params.docId}`, {}, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    )
  }
};




export const getDocumentsStatic = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documents/getAllStatic`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          if (response.docs) {
            /*dispatch({
              type: "LIST_DOCUMENT_MENU",
              data: response
            });*/
          }
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};


// export const getQueue = (params, callback) => {
//   return (dispatch, getState) => {
//       const { user: { token } } = getState();
//       dispatch({ type: "ISLOADING", data: true });
//       ApiClient.get(`${apiUrl}${PORT}/document/queue`, params, token, dispatch).then(
//           (response) => {
//               dispatch({ type: "DOCUMENT_LOGS_LISTING", data: response });
//               if (response && !response.errors) {
//                   dispatch({ type: 'LIST_QUEUE', data: response });
//                   callback && callback(response)
//               } else if (response.code === 404) {
//                   toast.error(response.message);
//                   callback && callback(false)
//               } else {
//                   toast.error(response.errors.msg, toasterConfig);
//                   callback && callback(false)
//               }
//           }
//       );
//   };
// };

//------------------------------------------------//
export const updateloanlist = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.post(
      `${apiUrl}${PORT}/documents/updateActiveRecord`,
      params,
      token,
      dispatch
    ).then((response) => {
      callback(response)
    })
  }
}

//------------------------------------------------//
export const getDocumentsById = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/files`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response?.errors) {
        dispatch({ type: "LIST_DOCUMENT", data: response.docs, totalDocRecords: response.totalDocs, folder: params.folder });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};

export const getDocumentsByIdWithTypes = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/filesWithTypes`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response?.errors) {
        dispatch({ type: "LIST_DOCUMENT", data: response.docs, totalDocRecords: response.totalDocs, folder: params.folder });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};

export const getAllReviewRequestedDocuments = (params, callback) => {
  params.limit = 10;
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/getAllReviewRequestedDocuments`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response?.errors) {
        // dispatch({ type: "LIST_DOCUMENT", data: response.docs, totalDocRecords: response.totalDocs, folder: params.folder });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};

export const getAllLabeledDocuments = (params, callback) => {
  params.limit = 10;

  console.log('params.limit', params.limit)
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/getAllLabeledDocuments`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response?.errors) {
        // dispatch({ type: "LIST_DOCUMENT", data: response.docs, totalDocRecords: response.totalDocs, folder: params.folder });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};

export const getAllCUTVDocuments = (params, callback) => {
  params.limit = 10;

  console.log('params.limit', params.limit)
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/getAllCUTVDocuments`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response?.errors) {
        console.log(response, "response")
        // dispatch({ type: "LIST_DOCUMENT", data: response.docs, totalDocRecords: response.totalDocs, folder: params.folder });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};

export const getAllOtherDocuments = (params, callback) => {

  params.limit = 10;
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/getAllOtherDocuments`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response?.errors) {
        // dispatch({ type: "LIST_DOCUMENT", data: response.docs, totalDocRecords: response.totalDocs, folder: params.folder });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};

export const getAllOtherLabeledDocuments = (params, callback) => {

  params.limit = 10;
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/getAllOtherLabeledDocuments`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response?.errors) {
        // dispatch({ type: "LIST_DOCUMENT", data: response.docs, totalDocRecords: response.totalDocs, folder: params.folder });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};


export const appendDocumentsById = (params, callback) => {

  params.limit = 10;
  let useState = false;
  if (params.fromAdmin) {
    useState = params.fromAdmin;
    delete params.fromAdmin;
  }
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/moreFilesByType`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response.errors) {
        if (!useState) {
          dispatch({ type: "APPEND_DOCUMENT_LIST", data: response.docs, totalDocs: response?.totalDocs });
        }
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};



export const findDocumentsById = (params, callback) => {

  params.limit = 10;
  let useState = false;
  if (params.fromAdmin) {
    useState = params.fromAdmin;
    delete params.fromAdmin;
  }
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/moreFilesByType`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response.errors) {
        let docs = [];
        let totalDocs = response?.totalDocs;
        if (params?.selectedDocument) {
          docs = [params.selectedDocument, ...response.docs];
          totalDocs = totalDocs + 1;
        } else {
          docs = response.docs;
        }
        if (!useState) {
          dispatch({ type: "LIST_DOCUMENT", data: docs, totalDocRecords: totalDocs, folder: params?.folder });
        }
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};



export const getDocumentDetailById = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/files`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response.errors) {
        dispatch({ type: "LIST_FILE_MENU", data: response });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};

export const getFileCSVData = (params, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/fileCsvData`,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        dispatch({ type: "DOCUMENT_URL", data: response });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.errors.msg, toasterConfig);
      }
    });
  };
};

export const addNewTag = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/addNewTag`
    ApiClient.post(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      callback(response)
    })
  }

}

export const getFile = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/file/${params.docId}`

    dispatch({ type: "ISLOADING", data: true });

    ApiClient.get(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      console.log('res of get file ->', response)
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {

        dispatch({ type: "DOCUMENT_DATA", data: response });
        dispatch({ type: "PAGE", data: response?.page });
        dispatch({ type: "JSON_META", data: response?.json, page: response?.page }); // temp store json file data
        dispatch({ type: "XML_META", data: response?.xml, page: response?.page });
        dispatch({ type: "VALIDATION_JSON", data: response?.validationJson });
        dispatch({ type: "FILE_VERSION", data: response?.fileVersions });
        dispatch({ type: "REVISIONS", data: response?.revisionsId.length > 0 ? response?.revisionsId : [] });
        dispatch({ type: "FILE_LATEST_VERSION", data: response?.latestVersion });
        dispatch({ type: "FILE_LATEST_REVISION", data: response?.latestRevision });
        dispatch({ type: "FILE_SELECTED_VERSION", data: response?.version });
        // dispatch({ type: "IS_DRAFT", data: response?.isDraft });
        // dispatch({ type: "SET_RIGHTSIDEBAR", data: response?.draft? "C":""})//this is used to display prefilled data in tags in draft mode also used to display prefilled data if we save draft data , also to enable Save button
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

export const getFileByRevision = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/fileByRevision/${params.docId}`

    ApiClient.get(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {

        dispatch({ type: "DOCUMENT_DATA", data: response });
        dispatch({ type: "PAGE", data: response?.page });
        dispatch({ type: "JSON_META", data: response?.json, page: response?.page }); // temp store json file data
        dispatch({ type: "XML_META", data: response?.xml, page: response?.page });
        dispatch({ type: "VALIDATION_JSON", data: response?.validationJson });
        dispatch({ type: "FILE_VERSION", data: response?.fileVersions });
        dispatch({ type: "REVISIONS", data: response?.revisionsId.length > 0 ? response?.revisionsId : [] });
        dispatch({ type: "FILE_LATEST_VERSION", data: response?.latestVersion });
        dispatch({ type: "FILE_LATEST_REVISION", data: response?.latestRevision });
        dispatch({ type: "FILE_SELECTED_VERSION", data: response?.version });
        // dispatch({ type: "IS_DRAFT", data: response?.isDraft });
        // dispatch({ type: "SET_RIGHTSIDEBAR", data: response?.draft? "C":""})//this is used to display prefilled data in tags in draft mode also used to display prefilled data if we save draft data , also to enable Save button
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

export const prevFileData = (params) => {
  return (dispatch) => {
    dispatch({ type: "PREV_DOC_RECORD", data: params });
  }

}

// export const updateSelectedFileWithUpdatedSocketId = (params, callback) => {
//   return (dispatch, getState) => {
//     const {
//       user: { token },
//     } = getState();
//     let url = `${apiUrl}${PORT}/documents/updateSelectedFileWithUpdatedSocketId`
//     ApiClient.post(
//       url,
//       params,
//       token,
//       dispatch
//     ).then((response) => {
//       callback(response)
//     })
//   }

// }

export const getFileDoc = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/fileDoc/${params.docId}`
    ApiClient.get(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        dispatch({ type: "DOCUMENT_DATA", data: response });
        dispatch({ type: "PAGE", data: response?.page });
        dispatch({ type: "JSON_META", data: response?.json, page: response?.page }); // temp store json file data
        dispatch({ type: "XML_META", data: response?.xml, page: response?.page });
        dispatch({ type: "VALIDATION_JSON", data: response?.validationJson });
        dispatch({ type: "FILE_VERSION", data: response?.fileVersions });
        console.log('dasvwrfd 6')
        dispatch({ type: "REVISIONS", data: response?.revisionsId.length > 0 ? response?.revisionsId : [] });
        console.log('dasvwrfd 7')
        dispatch({ type: "FILE_LATEST_VERSION", data: response?.latestVersion });
        dispatch({ type: "FILE_LATEST_REVISION", data: response?.latestRevision });
        dispatch({ type: "FILE_SELECTED_VERSION", data: response?.version });
        //   dispatch({ type: "IS_DRAFT", data: response?.isDraft });
        // dispatch({ type: "SET_RIGHTSIDEBAR", data: response?.draft? "C":""})//this is used to display prefilled data in tags in draft mode also used to display prefilled data if we save draft data , also to enable Save button
        console.log('dasvwrfd endddd')
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

export const getUnlabeledFileDoc = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/unlabeledFileDoc/${params.docId}`
    ApiClient.get(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        dispatch({ type: "DOCUMENT_DETAIL_ID", data: response._id });

        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

export const getDennisConfiguration = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/getDennisConfiguration`
    ApiClient.post(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};


export const getDocumentTypesById = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documentTypes/getDocumentById/${params.typeId}`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          callback();
          toast.error(response.message);
        } else {
          callback();
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};




export const getFilePage = (params, callback) => {

  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();

    let url = `${apiUrl}${PORT}/documents/file/${params.docId}`
    // if (params.isDraft) {
    //   url = `${apiUrl}${PORT}/documents/tempfile/${params.docId}`
    // }

    dispatch({ type: "ISLOADING", data: true });
    ApiClient.get(

      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        dispatch({ type: "DOCUMENT_DATA", data: response });
        if (response?.page) {
          dispatch({ type: "PAGE", data: response?.page });
        } else {
          dispatch({ type: "PAGE", data: params.pageNumber });
        }
        dispatch({ type: "JSON_META_PAGE", data: response?.json, page: response?.page }); // temp store json file data
        dispatch({ type: "XML_META_PAGE", data: response?.xml, page: response?.page });
        dispatch({ type: "FILE_VERSION", data: response?.fileVersions });
        dispatch({ type: "FILE_LATEST_VERSION", data: response?.latestVersion });
        dispatch({ type: "FILE_LATEST_REVISION", data: response?.latestRevision });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};





export const getDocumentDetailListById = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/documents/files`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response) {
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};

export const getDocumentsList = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documents`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          dispatch({ type: "APPEND_FOLDER_LIST", data: response.docs });
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

export const updateDocumentFile = (data, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents`, data, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          // dispatch({ type: "UPDATE_DOCUMENT_FAV_STATUS", data: data });
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};





export const deleteDocumentFile = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/${params.id}`
    ApiClient.delete(
      url,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        dispatch({ type: "UPDATE_FOLDER_DATA", data: response }); //to update C and V icon on folder level color when file is archived
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.errors.msg, toasterConfig);
      }
    });
  };
};


export const pdfDataSave = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/savePdfData`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        // dispatch({ type: "FILE_LATEST_VERSION", data: response?.version });
        // dispatch({ type: "FILE_SELECTED_VERSION", data: response?.version });
        toast.success('New version saved', toasterConfig);
        callback(response);
      } else {
        toast.error(response.errors.msg, toasterConfig);
        return callback(response);
      }
    });
  }
};



export const validateJsonData = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/validateJson`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {

        // dispatch({ type: "FILE_LATEST_VERSION", data: response?.version });
        //  dispatch({ type: "FILE_SELECTED_VERSION", data: response?.version });
        toast.success('Success', toasterConfig);
        callback(response);
      } else {
        toast.error("Validation Incomplete: The document validation process encountered an error. Please contact MORi support for assistance.", toasterConfig);
        callback(false);
      }
    });
  }
};


export const sendToLos = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/sendToLos`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        toast.success('Success', toasterConfig);
        callback(response);
      } else {
        toast.error("Validation Incomplete: The document validation process encountered an error. Please contact MORi support for assistance.", toasterConfig);
        callback(false);
      }
    });
  }
};

export const sendToHalcyon = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/sendToHalcyon`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        toast.success('Success', toasterConfig);
        callback(response);
      } else {
        toast.error("Validation Incomplete: The document validation process encountered an error. Please contact MORi support for assistance.", toasterConfig);
        callback(false);
      }
    });
  }
};








export const sendToIA = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/sendToIA`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        toast.success('Success', toasterConfig);
        callback(response);
      } else {
        toast.error("Validation Incomplete: The document validation process encountered an error. Please contact MORi support for assistance.", toasterConfig);
        callback(false);
      }
    });
  }
};


export const sendToAnalyzer = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/sendToAnalyzer`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        toast.success('Success', toasterConfig);
        callback(response);
      } else {
        toast.error("Validation Incomplete: The document validation process encountered an error. Please contact MORi support for assistance.", toasterConfig);
        callback(false);
      }
    });
  }
};


export const processValidation = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/processValidation`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        toast.success(response.message, toasterConfig);
        callback(response);
      } else {
        toast.error(response.errors.msg, toasterConfig);
      }
    });
  }
};


export const generateOutput = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/generateOutput`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        toast.success(response.message, toasterConfig);
        callback(response);
      } else {
        toast.error(response.errors.msg, toasterConfig);
      }
    });
  }
};




export const saveValidateJsonData = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/saveValidateJson`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        dispatch({ type: "UPDATE_FOLDER", data: response });
        toast.success(response.msg, toasterConfig);
        callback(response);
      } else {
        toast.error(response.errors.msg, toasterConfig);
        return callback(response);
      }
    });
  }
};




export const saveUnableToValidateJsonData = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    console.log('params', params)
    ApiClient.post(`${apiUrl}${PORT}/documents/saveUnableToValidateJson`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        // dispatch({ type: "UPDATE_FOLDER", data: response });
        // toast.success(response.msg, toasterConfig);
        callback(response);
      } else {
        toast.error(response.errors.msg, toasterConfig);
        return callback();
      }
    });
  }
};



export const revelidateDocument = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/revelidateDocument`, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      toast.dismiss();
      if (response && !response.errors) {
        // dispatch({ type: "UPDATE_FOLDER", data: response });
        toast.success(response.msg, toasterConfig);
        callback(response);
      } else {
        toast.error(response.errors.msg, toasterConfig);
        return callback();
      }
    });
  }
};





export const updateDocumentFileStatus = (data, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents/updateStatus`, data, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          dispatch({ type: "UPDATE_FOLDER_DATA", data: response }); //to update C and V icon color on folder level when restored

          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

export const updateDocumentIsCorrect = (data, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents/updateIsCorrect`, data, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

/**
 * @description function use for to get folder elastic search 
 * @param {*} params accepting object (name, is_verified, is_correct)
 */

export const getElasticSearchFolders = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/upload/search`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {

          return callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};


/**
 * @description function use for to get documents elastic search 
 * @param {*} params accepting object (name, is_verified, is_correct)
 */
export const getElasticSearchDocuments = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documents/search`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {

          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};



export const getDocumentTypes = (params, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documents/types`, params, token, dispatch).then(
      (response) => {
        dispatch({ type: "ISLOADING", data: false });
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          callback();
          toast.error(response.message);
        } else {
          callback();
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};



export const getMainParent = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/documentTypes/getMainParent`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          callback();
          toast.error(response.message);
        } else {
          callback();
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

export const updateLabelType = (data, callback) => {
  return (dispatch, getState) => {

    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents/updateLabelType`, data, token, dispatch).then(
      (response) => {

        dispatch({ type: "ISLOADING", data: false });
        if (response && !response.errors) {

          toast.success(response.msg, { autoClose: 10000, hideProgressBar: true });
          callback(response?.data);


        } else if (response.code === 404) {
          toast.error(response.message);
          callback();
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback();
        }
      }
    );
  };
};



export const updateDocumentType = (data, callback) => {
  return (dispatch, getState) => {

    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents/updateDocumentType`, data, token, dispatch).then(
      (response) => {

        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
          callback();
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback();
        }
      }
    );
  };
};

export const updateDocumentAccepted = (data, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents/updateIsAccepted`, data, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
          callback();
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback();
        }
      }
    );
  };
};

export const rightsidebar = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_RIGHTSIDEBAR", data: param });
  }
};
export const leftsidebarcicon = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_LEFTSIDEBARCICON", data: param });
  }
};

export const documentAccepted = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_ACCEPTED", data: param });
  }
};

export const set_page_number = (param) => {
  return (dispatch) => {
    dispatch({ type: "PAGE", data: Number(param) });
  }
};
export const set_is_right_clicked = (param) => {
  return (dispatch) => {
    dispatch({ type: "RIGHT_TAG_CLICKED", data: param });
  }
};

export const processDocsLocal = (callback) => {

  return (dispatch, getState) => {
    const { user: { token } } = getState();

    ApiClient.get(`${apiUrl}${PORT}/documents/processDocsLocal`, {}, token, dispatch).then((response) => {
      if (response && !response.errors) {

        // toast.success(response.message, toasterConfig);
        return callback(response);

      } else if (response.messageID === 404) {
        toast.error(response.message);
        //return callback();
      } else {
        toast.error(response.errors.msg)
        return callback(response);
      }
    });
  }
};




//genearte csv ticket 392
export const generateCSV = (params, callback) => {
  return (dispatch, getState) => {

    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/generateCSV`
    ApiClient.post(url, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        callback(response);
      } else if (response.messageID === 500) {
        toast.error(response.errors.msg);
        callback(response)
      } else {
        callback(response)
      }
    });
  };
};

export const generateFinalCSV = (params, callback) => {
  return (dispatch, getState) => {

    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/GenerateFinalDocCsv`
    ApiClient.post(url, params, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        callback(response);
      } else if (response.messageID === 500) {
        toast.error(response.errors.msg);
        callback(response)
      } else {
        callback(response)
      }
    });
  };
};



export const prevActiveId = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_PREV_ACTIVEID", data: param });
  }
};


export const getFileDetail = (params, callback) => {

  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/fileDoc/${params.docId}`

    ApiClient.get(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

export const documentLogListing = (params, callback) => {

  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/documentLogs/${params.docId}`

    ApiClient.get(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "DOCUMENT_LOGS_LISTING", data: response });
      if (response && !response.errors) {
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

export const saveUnlabeledPdfData = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/saveUnlabeledPdfData`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    )
  }
};

export const saveDraftJson = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.post(`${apiUrl}${PORT}/documents/createDraftJson`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    )
  }
};

export const fetchMails = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.post(`${apiUrl}${PORT}/documents/fetchMailfromDoc`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          dispatch({ type: "ISLOADING", data: false });
          callback(response);
        } else if (response.code === 404) {
          dispatch({ type: "ISLOADING", data: false });
          // toast.error(response.message);
          // callback(response);
        } else {
          dispatch({ type: "ISLOADING", data: false });
          // toast.error(response.errors.msg, toasterConfig);
          callback(response);
        }
      }
    );
  };
}

export const downloadFiles = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.get(`${apiUrl}${PORT}/documents/downloadFiles`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
          dispatch({ type: "ISLOADING", data: false });
        } else if (response.code === 404) {
          toast.error(response.message);
          dispatch({ type: "ISLOADING", data: false });
        } else {
          toast.error(response.errors.msg, toasterConfig);
          dispatch({ type: "ISLOADING", data: false });
        }
      }
    );
  };
};

export const getDocumentPage = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/getDocumentPage`
    ApiClient.get(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        console.log('dasvwrfd endddd')
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};



export const updateSocketId = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/updateSocketId`
    ApiClient.get(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        console.log('dasvwrfd endddd')
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

export const saveQAVerification = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    let url = `${apiUrl}${PORT}/documents/saveQAVerification`
    ApiClient.post(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        toast.success(response.message)
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};


export const updateCompleteStatus = (data, callback) => {

  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents/updateCompleteStatus`, data, token, dispatch).then(
      (response) => {
        dispatch({ type: "ISLOADING", data: false });
        if (response && !response.errors) {
          toast.success(response.message)
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

export const saveAsTriage = (data, callback) => {

  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents/saveAsTriage`, data, token, dispatch).then(
      (response) => {
        dispatch({ type: "ISLOADING", data: false });
        if (response && !response.errors) {
          toast.success(response.message)
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

export const getDocumentTypeRules = (data, callback) => {

  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.put(`${apiUrl}${PORT}/documents/getDocumentTypeRules`, data, token, dispatch).then(
      (response) => {
        dispatch({ type: "ISLOADING", data: false });
        if (response && !response.errors) {
          // toast.success(response.message)
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};